import React, { useRef, useEffect, useState } from 'react';
import Lottie from 'react-lottie';
import styles from './index.module.scss';
import starData from '@/assets/lottie/star-data.json';
import screen1Video from '@/assets/home/screen1-video/new-screen1-background-video.mp4';
import screen1Poster from '@/assets/home/screen1-video/first-shot.jpg';

const starLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: starData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function Screen1() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleCanPlay = () => {
      setVideoReady(true);
      video.play().catch(() => {});
    };

    video.addEventListener('canplaythrough', handleCanPlay);

    return () => {
      video.removeEventListener('canplaythrough', handleCanPlay);
    };
  }, []);

  return (
    <section className={styles['screen1-cover']}>
      <img
        src={screen1Poster}
        className={styles['screen1-video-bg']}
        alt=""
        style={{
          opacity: videoReady ? 0 : 1,
          transition: 'opacity 0.3s ease',
        }}
      />

      <video
        ref={videoRef}
        className={styles['screen1-video-bg']}
        src={screen1Video}
        muted
        loop
        playsInline
        preload="auto"
        style={{
          opacity: videoReady ? 1 : 0,
          transition: 'opacity 0.6s ease',
        }}
      />

      {/* 内容区域 */}
      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-title']}`}
            style={{ animationDelay: '0.2s', animationDuration: '1s' }}
          >
            <div className={styles['screen1-title-row']}>
              <div>AI学就爱学</div>
              <span className={styles['screen1-star-wrap']} aria-hidden>
                <Lottie options={starLottieOptions} />
              </span>
            </div>
            <div>你的专属AI一对一导师</div>
          </div>
        </div>
      </div>
    </section>
  );
}
